import React, { createContext, useContext, useEffect, useState } from 'react';
import { isEmbeddedMode } from '../utils/iframe';

interface EmbeddedContextType {
  isEmbedded: boolean;
}

const EmbeddedContext = createContext<EmbeddedContextType>({
  isEmbedded: false,
});

export const useEmbedded = () => useContext(EmbeddedContext);

interface EmbeddedProviderProps {
  children: React.ReactNode;
}

export const EmbeddedProvider: React.FC<EmbeddedProviderProps> = ({ children }) => {
  const [isEmbedded, setIsEmbedded] = useState(false);

  useEffect(() => {
    setIsEmbedded(isEmbeddedMode());
  }, []);

  return (
    <EmbeddedContext.Provider value={{ isEmbedded }}>
      {children}
    </EmbeddedContext.Provider>
  );
};
